import React, { useState } from 'react';
import Rail from './Rail';
import Bus from  './Bus';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { getGoogleTime } from '../services/TransitService';
import { useTranslation } from "react-i18next";

import appConfig from '../config/appConfig.json'

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#ffffff',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
      boxShadow: theme.shadows[10],
      borderRadius: 0,
    },
  }));

function ResultRow(props) {
    const [transitTimes, setTransitTimes] = useState(null);
    const { t } = useTranslation();

    const feederDoc = appConfig.feederPatternDoc;

    const formatGradesServed = (served)=> {
        if (!served) return "";

        if (served.constructor === Array) {
            if (served.length===0) {
                return "";
            } else if (served.length===1){
                return served[0];
            } else {
                let start = served[0].replace(/_/g, '').toUpperCase();
                let end = served[served.length-1].replace(/_/g, '').toUpperCase();
                return start + "-"+ end;
            }
        }
    }

    const getTransitTimes = (address) => {
        let startAddress =  props.searchedAddress.properties.FullAddress + ", Washington, DC";
        let endAddress = address + ", Washington, DC";
        getGoogleTime({start: startAddress, end: endAddress}).then((data) => {
            // set the state of transit object
            setTransitTimes(data);
        }, (error) => {
            // handle failure to get
            console.log(error);
            setTransitTimes("Error getting transit times")
        })
    }

    const showTransitTimes = () => {
        // only show transit times if start and end address are not the same
        return props.searchedAddress.properties.FullAddress !== props.data.properties.addressInfo.address;
    }

    return (
        <div className={'w-full py-2 ' + ((props.data.properties && props.data.properties.inBoundary === true)? 'border-[3px] border-[#E64534]':'border-b-[1px] border-b-[#e0e0e0]')}>
            <div className='flex mt-2 flex-row'>
                <div className={'rounded-full w-[31px] h-[31px] leading-[29px] border border-my-emerald flex justify-center items-center font-extrabold mx-[10px]' + ((props.data.properties && props.data.properties.inBoundary === true)? ' text-[#E64534] ':' text-my-emerald')}>
                    {
                        props.data.rank.length > 4 ?
                            <span className='leading-[11px] text-[11px] flex flex-col text-center font-extrabold'> {
                                props.data.rank.split(",").map(item => {
                                    return <span key={item}>{item}</span>
                                })
                            }
                            </span>
                        :
                            <span className={((props.data.rank.toString().length > 2) ? 'text-xs':'text-sm')}>{props.data.rank}</span>
                    }
                </div>
                <div className='flex flex-col lg:flex-row print:flex-row w-full'>
                    <div className='flex w-full lg:w-1/2 xl:w-1/3 print:w-3/6'>
                        <div className='w-full lg:w-[255px] mr-[20px]'>
                            <h2 className='text-sm lg:text-[15px] lg:font-bold lg:min-h-[42px] leading-[1.25em] lg:hover:underline underline lg:no-underline'>
                                <a href={props.data.properties.schoolInfo.website} target="_blank" rel="noreferrer">{props.data.properties.name}</a>
                            </h2>
                            <p className='hidden print:block lg:block text-[10px]'>
                            {props.data.properties.addressInfo.address}
                            <br/>
                            {props.data.properties.addressInfo.city}, {props.data.properties.addressInfo.state} {props.data.properties.addressInfo.zip}
                            </p>
                        </div>
                    </div>

                    <div className='w-full lg:block lg:w-1/4 xl:w-1/6 print:hidden'>
                        <p className='text-sm lg:text-[10px] mr-[7px] lg:mb-[20px]'>
                            <span className='lg:hidden'>{t('result.gradeserved')}: </span>
                            {formatGradesServed(props.data.properties.grades_served)}
                        </p>
                        
                        {
                            props.data.properties.feederSchool && 
                            <span className='hidden lg:flex flex-col text-[10px] mr-[7px]'>
                                <a rel="noreferrer" className='text-my-emerald hover:underline' href={feederDoc} target="_blank">{t('result.feedsinto')}</a>
                                <p>{props.data.properties.feederSchool}</p>
                            </span>
                        }   
                        
                    </div>

                    <div className='w-full lg:block lg:w-1/4 xl:w-1/12 text-[14px] lg:text-[10px] print:hidden'>
                        <p className='lg:font-bold'>
                            <span className='lg:hidden'>{t('result.distance')}: </span>
                            { (props.data.distance !== null ) ? props.data.distance + " mi.": "-" }
                        </p>
                        {
                            (props.data.distance !== null && showTransitTimes()) && <div>
                                {
                                    transitTimes == null ?
                                        <div onClick={() => getTransitTimes(props.data.properties.addressInfo.address)} className='text-my-emerald cursor-pointer pr-3'>{t('result.viewtransittime')}</div>
                                    :
                                        <div>
                                            {
                                                transitTimes.hasOwnProperty('driving') ? 
                                                    <><p className='font-bold text-[8px] text-my-emerald mt-[5px]'>
                                                        {t('result.driving')}:
                                                    </p>
                                                    <p className='text-[8px] text-my-emerald'>
                                                        { transitTimes["driving"] }
                                                    </p>
                                                    <p className='font-bold text-[8px] text-my-emerald mt-[5px]'>
                                                        {t('result.busrail')}:
                                                    </p>
                                                    <p className='text-[8px] text-my-emerald'>
                                                        { transitTimes["bus_rail"] }
                                                    </p></>
                                                :
                                                <p className='font-bold text-[8px] text-my-emerald'>{ transitTimes }</p>
                                            }
                                            
                                        </div>
                                }
                            </div>
                        }
                    </div>

                    <div className='hidden print:block xl:block w-3/12 print:w-1/3'>
                        <Rail stops={props.data.properties.metro_rail_service}/>
                        <Bus stops={props.data.properties.metro_bus_service}/>
                    </div>

                    <div className='md:text-[10px] w-1/6 print:w-1/6'>
                        <HtmlTooltip placement="left-start" enterTouchDelay={0}
                            title= {
                                <React.Fragment>
                                <h2 className='font-bold'>School Offerings</h2>
                                    <ul className='list-circle list-inside text-[10px]'>
                                        {
                                            (props.data.offeringMets)  && props.data.offeringMets.offeringMetItems.map((item, i) => {
                                                    return (
                                                        <li key={i} className={item.met? "": "line-through"} >{item.label}</li>
                                                    );
                                            })
                                        }
                                    </ul>
                            </React.Fragment>
                            }
                        >
                            <p className='text-[10px] underline lg:no-underline hover:underline'>{(props.data.offeringMets)? props.data.offeringMets.metRatio: " "}</p>
                        </HtmlTooltip>
                    </div>
                </div>
            </div>
            {
                props.data.properties.inBoundary &&
                    <div className='ml-[52px]  underline my-[1em] text-[13px] leading-[22px]'>
                        <a href={'https://www.myschooldc.org/faq/key-terms/#inboundpref'} target="_blank" rel="noreferrer">{t('result.inboundary')}</a>
                    </div>
            }
            {
                props.data.properties.optional &&
                    <div className='ml-[52px]  underline my-[1em] text-[13px] leading-[22px]'>
                        <a href={'https://www.myschooldc.org/faq/key-terms/#inboundpref'} target="_blank" rel="noreferrer">{t('result.optional')}</a>
                    </div>
            }            
            <div className='ml-[52px] text-[12px] my-[1em] schoolAlertMessage' dangerouslySetInnerHTML={{ __html: props.data.properties[t('result.alertfield')] }} />

        </div>
      );
} 

export default ResultRow;
